import { Spinner } from 'reactstrap';

const DefaultSpinner = (): JSX.Element => <Spinner type="grow" />;

export default DefaultSpinner;
